import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, variant = "default", ...props }, ref) => {
  const variants = {
    default: "border-input bg-background focus-visible:ring-ring",
    luxury: "border-silver/30 bg-muted focus-visible:ring-silver focus-visible:border-silver/50",
    ivory: "border-silver/20 bg-ivory/5 text-foreground placeholder:text-muted-foreground focus-visible:ring-silver focus-visible:border-silver/40",
  }
  
  return (
    <input
      type={type}
      className={cn(
        "flex h-11 w-full rounded-lg border px-4 py-2 text-base shadow-sm transition-all duration-300 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        variants[variant] || variants.default,
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
